import {
  getRealm,
  Hostname,
} from "@twiliointernal/e2-commons-shared-definitions";

export const twilioRealm =
  getRealm(window.location.hostname as Hostname) || "prod";

export const gitSha = process.env.NX_GIT_SHA;

export const DATADOG_LOG_CLIENT_TOKEN = "pubd3d59a4478ae4b468bb4f6a7c856a6cb";
